// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"f48677d4","180":"72a13536","331":"878a99f0","404":"334fe94a","425":"7614ef40"}[chunkId] + ".chunk.js";
};